/***************************************************************************/
"use client";
/***************************************************************************/

const ScreenContent: React.FC<React.HTMLAttributes<HTMLDivElement>> = ({
  children,
  ...props
}) => {
  return <div {...props}>{children}</div>;
};

export { ScreenContent };
